/** Temporary function to define if we are within the Christmas period event of 2025. */
export function isChristmasPeriod(): boolean {
    const today = new Date();

    console.info(process.env.NODE_ENV);

    return (
        today.getFullYear() === 2025 && today.getMonth() === 11 // start at 0 so 11 is December
    );
}
